
export const KbFileNoToolOption = 'none';

export const LlmKnowledgeBaseCreationMode = {
  appAndTools: 'appAndTools',
  appOnly: 'appOnly',
  toolsOnly: 'toolsOnly',
  specificTool: 'specificTool',
} as const;

export const textToChunksLastUnparsed = {
  text: '',
};
